import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration, UzurvRestService } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ComplianceStatus } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class ComplianceStatusService extends UzurvRestService {
  readonly resourceUrl = 'compliance/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  listActiveComplianceStatuses(): Observable<Array<ComplianceStatus>> {
    return this.get(`${this.resourceUrl}`).pipe(map(response => Deserialize(response, ComplianceStatus)));
  }

  protected getApiUrl(): string {
    return this.uzurvRestConfiguration.dotsApiUrl;
  }
}
